import { TrashIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

import { cn } from "utils/cn";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "components/AlertDialog";
import Button from "components/Button";

import { ReactComponent as PriorityHigh } from "assets/priority_high.svg";

import useDeleteTemplateDialog from "./useDeleteTemplateDialog";

export default function DeleteReportTemplateDialog({ id }: { id: string }) {
  const { t } = useTranslation();

  const { deleteReportTemplateMutation } = useDeleteTemplateDialog();

  return (
    <AlertDialog>
      <AlertDialogTrigger className="cursor-pointer" onClick={(e) => e.stopPropagation()}>
        <TrashIcon className="size-5 cursor-pointer" />
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <div
            className={cn(
              "w-20 h-20 m-auto mb-5  rounded-full flex items-center justify-center bg-general-orange-700 border border-general-orange-800",
            )}
          >
            <PriorityHigh className="w-16 h-16 fill-general-orange-900" />
          </div>
          <AlertDialogTitle className="text-center">
            {t("profile.reportTemplate.deleteReportTemplateDialog.title")}
          </AlertDialogTitle>
          <AlertDialogDescription className="text-center">
            {t("profile.reportTemplate.deleteReportTemplateDialog.description")}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel asChild>
            <Button variant="secondary" className="w-full md:flex-1">
              {t("button.cancel")}
            </Button>
          </AlertDialogCancel>

          <AlertDialogAction asChild>
            <Button
              form="report-template-form"
              type="button"
              className="w-full md:flex-1"
              onClick={() => deleteReportTemplateMutation.mutate(id)}
            >
              {t("button.confirm")}
            </Button>
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
